import { render, staticRenderFns } from "./banner-carousel.vue?vue&type=template&id=541f425d&scoped=true"
import script from "./banner-carousel.vue?vue&type=script&lang=js"
export * from "./banner-carousel.vue?vue&type=script&lang=js"
import style0 from "./banner-carousel.vue?vue&type=style&index=0&id=541f425d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f425d",
  null
  
)

export default component.exports